
<loader *ngIf="params.loading"></loader>
<div class="body-container">
  <param-box *ngFor="let p of params" [subject]="p"></param-box>
</div>
